import { Task } from './-private/task';
import { deprecatePrivateModule } from './-private/utils';
deprecatePrivateModule('ember-concurrency/-task-property');
export { Task };
